import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const AdminPanelCard = ({
  title = '',
  subtitle = '',
  action = null,
  children,
  contentSx = {},
  sx = {},
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        border: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
        backgroundColor: theme.palette.background.paper,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {(title || subtitle || action) ? (
        <Box
          sx={{
            px: { xs: 2, md: 2.4 },
            py: 1.7,
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.55)}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1.5,
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            {title ? (
              <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                {title}
              </Typography>
            ) : null}
            {subtitle ? (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.35, fontSize: '0.84rem' }}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
          {action}
        </Box>
      ) : null}

      <Box sx={{ p: { xs: 2, md: 2.4 }, ...contentSx }}>{children}</Box>
    </Paper>
  );
};

AdminPanelCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node.isRequired,
  contentSx: PropTypes.object,
  sx: PropTypes.object,
};

export default AdminPanelCard;
